import EnbItem01 from './Produto01/EnbItem01'
import EnbItem02 from './Produto02/EnbItem02'

export default {
  EnbItem01,
  EnbItem02
}
